import { fetchExperiencesById } from 'actions/ExperienceActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useStableObjectReference from 'hooks/useStableObjectReference'
import { useEffect, useMemo } from 'react'

function useExperiences(experienceIds: Array<string> = []): [Array<App.ExperienceOffer>, boolean] {
  const dispatch = useAppDispatch()

  const stableExperienceIds = useStableObjectReference(experienceIds)

  useEffect(() => {
    dispatch(fetchExperiencesById(...stableExperienceIds))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stableExperienceIds])

  const experience = useAppSelector(state => state.experience.experiences)
  const fetchingMap = useAppSelector(state => state.experience.fetchingExperiences)

  const experiences = useMemo(() => stableExperienceIds.map(id => experience[id]).filter(Boolean), [experience, stableExperienceIds])
  const fetching = useMemo(() => stableExperienceIds.some(id => fetchingMap[id]), [stableExperienceIds, fetchingMap])

  return [experiences, fetching]
}

export default useExperiences
